import { Scale, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = {
    servicos: [
      { label: 'Horas Extras', href: '#problemas' },
      { label: 'Atraso na Rescisão', href: '#problemas' },
      { label: 'Reversão de Justa Causa', href: '#problemas' },
      { label: 'Trabalho sem Carteira', href: '#problemas' },
    ],
    empresa: [
      { label: 'Como Funciona', href: '#como-funciona' },
      { label: 'Vantagens', href: '#servicos' },
      { label: 'Dúvidas Frequentes', href: '#faq' },
      { label: 'Contato', href: '#contato' },
    ],
    legal: [
      { label: 'Termos de Uso', href: '#' },
      { label: 'Privacidade (LGPD)', href: '/politica-de-privacidade' },
      { label: 'Provimento OAB 205/2021', href: '#' },
    ],
  };

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 text-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
                <Scale className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg">
                Meus Direitos Trabalhistas
              </span>
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Transformamos seu problema em solução. Defesa exclusiva do trabalhador de forma simples, rápida e sem complicação.
            </p>
          </div>

          {/* Serviços */}
          <div>
            <h4 className="font-bold text-white mb-4">Principais Direitos</h4>
            <ul className="space-y-2.5">
              {links.servicos.map((link, idx) => (
                <li key={idx}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-bold text-white mb-4">Navegação</h4>
            <ul className="space-y-2.5">
              {links.empresa.map((link, idx) => (
                <li key={idx}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contato */}
          <div>
            <h4 className="font-bold text-white mb-4">Segurança & Ética</h4>
            <ul className="space-y-2.5 mb-4">
              {links.legal.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-xs text-slate-500 leading-relaxed">
              Atendimento informativo em conformidade com o Código de Ética e Provimento 205/2021 da OAB.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Meus Direitos Trabalhistas. Todos os direitos reservados.
          </p>
          <p className="text-slate-500 text-xs">
            Feito para defender quem trabalha. Você só paga se ganhar.
          </p>
        </div>
      </div>
    </footer>
  );
};
